import React, { useCallback, useEffect } from 'react';
import { Button, Card, Form, Row } from "react-bootstrap";
import Header from '../common/Header';
import useDocument from '../../hooks/useDocument';
import { extractFileName, validateDocumentId } from '../../utils/common';
import AlertMessage from '../common/AlertMessage';
import Footer from '../common/Footer';
import { useLocation } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { properties } from '../../constants/commonConstants';

const DocumentView: React.FC = () => {

  const [documentId, setDocumentId] = React.useState("");
  const [alertMessage, setAlertMessage] = React.useState({
    message: "",
    type: "success"
  })
  const [downloading, setDownloading] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);
  const [showCaptcha, setShowCaptcha] = React.useState(false);
  const [captchaCount, setCaptchaCount] = React.useState(0);
  const [showCaptchaWarning, setShowCaptchaWarning] = React.useState(false);

  const documentDownload = useDocument(documentId);
  const location = useLocation();

  const recaptchaRef: React.RefObject<any> = React.createRef();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');

    if (id !== null && id !== "") {
      setDownloading(true);
      setDocumentId(id);
    }
  }, []);

  useEffect(() => {
    if (downloading && !disabled) {
      previewDocument();
    }
  }, [documentId]);

  const captchaOnChange = useCallback((response: any) => {
    try {
      if (response) {
        setShowCaptchaWarning(false);
        setDisabled(false);
        setCaptchaCount(0);
      }
    } catch (error) {
      console.log(error);
    }

  }, []);

  useEffect(()=>{
    if(showCaptcha && captchaCount == 1){
      if(recaptchaRef.current){
        recaptchaRef.current.reset();
      }     
      setShowCaptcha(false);
    }
  },[captchaCount]);

  const previewDocument = useCallback(() => {

    setCaptchaCount(prevCaptchaCount => prevCaptchaCount + 1);
    if(showCaptcha && captchaCount > 4 ){  
      setShowCaptchaWarning(true);
      setDisabled(true);
    }
    if (captchaCount > 4) {
      setShowCaptcha(true);
    }
    else{
      previewContinue();
    }
  }, [captchaCount,documentId]);

  const previewContinue = useCallback(async ()=>{

    setDownloading(true)
    let error = validateDocumentId(documentId);
    if (error !== "") {
      setDownloading(false);
      setAlertMessage({
        message: error,
        type: "error"
      });
    }
    else {
      var resp = await documentDownload.mutateAsync();
      if (resp) {
        onSuccess(resp);
      }
      else {
        setDownloading(false);
        setAlertMessage({
          message: "Communication Error occured. Please try again.",
          type: "error"
        });
      }
    }
  },[documentId])


  const onSuccess = (data: any) => {
    let disposition = data.headers.get("Content-Disposition");
    let fileName = extractFileName(disposition);
    if (fileName === "untitled") {
      setDownloading(false);
      setAlertMessage({
        message: "Invalid document Id Number.",
        type: "error"
      });
      return;
    }
    const fileURL = URL.createObjectURL(data.data);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = fileURL;
    a.download = extractFileName(disposition) + ".pdf";
    a.click();
    setAlertMessage({
      message: "Document download successfully.",
      type: "success"
    });
    setDownloading(false);
  }

  const handleValChange = (e: any) => {
    if (e.target.value.length < 6){
      setDocumentId(e.target.value.toUpperCase());
    }
  }

  const handleKeyChange = (event:any) =>{
    if (event.key === "Enter" && !disabled){
      previewDocument();
    }
  }

  return (
    <div className='background-theme'>
      <Header headerName='' />
      <AlertMessage
        message={alertMessage.message}
        onClose={() => setAlertMessage({
          message: "",
          type: "success"
        })}
        variant={alertMessage.type === "success" ? alertMessage.type : "danger"}
      />
      <div className="modal-center">
        <Card className="center-body">
          <div className="model-logo">
            <img
              alt="logo"
              src={require("../../assets/logo.png")}
              className='app-icon'
            />
          </div>
          <div className="text-center">
          </div>
          <Card.Body>

            <hr />
            <div className="mb-3 fw-bold">
              <Row className='mt-5 ms-2'>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>Document Id</Form.Label>
                  <div className={alertMessage.type === "error" ? "border-err" : ""}>
                    <Form.Control type="text" placeholder="EIK60" onChange={handleValChange} value={documentId} onKeyDown ={handleKeyChange}/>
                  </div>

                </Form.Group>
              </Row>
            </div>

            {showCaptcha &&
            <div className='d-flex align-items-center justify-content-center'>
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY + ""}
                onChange={captchaOnChange}
                onExpired={() => {
                  recaptchaRef.current.reset();
                }}
              />
              </div>}
              {showCaptchaWarning && <div className='d-flex align-items-center justify-content-center small bold' style={{ color: 'red', fontWeight: '600' }}>Failed to verify with the reCAPTCHA server</div>}

            <div className="d-grid btn-preview">
              <Button variant='dark'
                onClick={() => previewDocument()}
                disabled={disabled ? true : downloading}
              >
                {downloading && !disabled ? (
                  <img src={require("../../assets/loading.gif")} alt="Loading GIF" style={{
                    width: "5%",
                    height: "auto"
                  }} />
                ) : (
                  'Download'
                )}
              </Button>
            </div>

          </Card.Body>
        </Card>
      </div>
      <Footer />
    </div>

  )
}

export default DocumentView;